import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { RandomUsernameService } from 'app/core/random-username.service';
import { ModalService } from 'app/shared/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorManagerService } from 'app/core/error-manager.service';
import { AlertService } from '@app/core/alert.service';
import { Response } from '@angular/http';
import * as amplitude from 'amplitude-js';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'app-signup-step-2-modal',
  templateUrl: './signup-modal.template.html',
  styleUrls: ['./signup-modal.template.scss'],
  animations: [],
})
export class SignupStep2ModalComponent implements OnInit, OnDestroy {
  form: FormGroup;
  loading = false;
  errors: string = null;
  success: string = null;
  userInfo$: Subscription = null;

  pixel: SafeHtml = null;

  @ViewChild('code1') code1: any;
  @ViewChild('code2') code2: any;
  @ViewChild('code3') code3: any;
  @ViewChild('code4') code4: any;
  @ViewChild('code5') code5: any;
  @ViewChild('code6') code6: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private nick: RandomUsernameService,
    private translate: TranslateService,
    private modalService: ModalService,
    private errorManager: ErrorManagerService,
    protected renderer: Renderer2,
    private alertService: AlertService,
    private sanitizer: DomSanitizer
  ) {
    // super(elemRef, renderer);
  }

  public ngOnInit() {
    // super.ngOnInit();
    this.createForm();

    this.userInfo$ = this.auth.userInfo$.subscribe(
      (user: any) => {
        if (user && user.emailVerified === true) {
          if (environment.verifyPhone) {
            this.router.navigate(['/', { outlets: { modal: 'phone-verify' } }], { queryParams: { onboarding: true } });
          } else {
            this.router.navigate(['/', { outlets: { modal: 'deposit' } }]);
          }
        } else if (user && user.emailVerified === false) {
          this.activatedRoute.queryParams.subscribe(params => {
            if (params['emailConfirmationToken']) {
              this.codeChange(params['emailConfirmationToken']);
            }
          });
        }
      },
      () => {}
    );
  }

  public ngOnDestroy() {
    if (this.userInfo$) {
      this.userInfo$.unsubscribe();
    }
  }

  public submit(): void {
    const code =
      this.form.get('code_1').value +
      this.form.get('code_2').value +
      this.form.get('code_3').value +
      this.form.get('code_4').value +
      this.form.get('code_5').value +
      this.form.get('code_6').value;
    if (code && code.length === 6) {
      this.loading = true;
      this.auth
        .confirmEmail(code)
        .pipe(
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe(
          (data: any) => {
            amplitude.getInstance().logEvent('Onboarding - Verify Email', {
              Success: true,
            });
            this.auth.getUserInfo().subscribe(
              () => {
                this.pixel = this.sanitizer.bypassSecurityTrustHtml(
                  `<iframe src="https://trk.exmox.net/pixel?adid=5c790e52b6920d217969fa42&txn_id=${
                    this.auth.userInfo._id
                  }" scrolling="no" frameborder="0" width="1" height="1"></iframe>`
                );
                setTimeout(() => {
                  if (environment.verifyPhone) {
                    this.router.navigate(['/', { outlets: { modal: 'phone-verify' } }], {
                      queryParams: { onboarding: true },
                    });
                  } else {
                    this.router.navigate(['/', { outlets: { modal: 'deposit' } }], {
                      queryParams: { onboarding: true },
                    });
                  }
                }, 300);
              },
              () => {}
            );
          },
          (error: any) => {
            amplitude.getInstance().logEvent('Onboarding - Verify Email', {
              Success: false,
            });
            this.alertService.error({
              title: 'Email confirmation error!',
              text: this.errorManager.errorToPrint(error.json()),
              timer: 5,
            });
          }
        );
    }
  }

  public resendCode($event: Event): void {
    $event.preventDefault();

    amplitude.getInstance().logEvent('Onboarding - Resend Code');

    this.auth.resendEmailConfirmation().subscribe(
      (data: Response) => {
        this.alertService.success({
          title: 'Success',
          text: 'Confirmation email was sent to your inbox.',
          timer: 15,
        });
      },
      e => {
        this.alertService.error({
          title: 'Error',
          text: 'Sorry, we are unable to send an email right now! Please try again in couple of minutes.',
          timer: 15,
        });
      }
    );
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      code_1: ['', [Validators.required]],
      code_2: ['', [Validators.required]],
      code_3: ['', [Validators.required]],
      code_4: ['', [Validators.required]],
      code_5: ['', [Validators.required]],
      code_6: ['', [Validators.required]],
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  codeChange(code: any, el: any = null) {
    if (code.length === 6) {
      this.form.patchValue({ code_1: code[0] });
      this.form.patchValue({ code_2: code[1] });
      this.form.patchValue({ code_3: code[2] });
      this.form.patchValue({ code_4: code[3] });
      this.form.patchValue({ code_5: code[4] });
      this.form.patchValue({ code_6: code[5] });
    } else if (code.length === 1 && el) {
      el.element.nativeElement.children[0].focus();
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/signup/2/signup-modal.component.ts